import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Products from './components/Products';
import MenuSection from './components/MenuSection';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Restaurant',
            name: "D'CURE Gelato",
            description:
              "Malacca's first artisan gelato cafe, crafting premium gelato, pastries, and beverages with natural ingredients and no preservatives.",
            url: 'https://dcuregelato.com',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'G3, Jalan Kampung Pantai',
              addressLocality: 'Melaka',
              postalCode: '75200',
              addressCountry: 'MY',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: 2.1969,
              longitude: 102.2473,
            },
            telephone: '+60 12-345 6789',
            email: 'hello@dcuregelato.com',
            openingHoursSpecification: {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday',
              ],
              opens: '11:00',
              closes: '22:00',
            },
            servesCuisine: ['Gelato', 'Pastries', 'Coffee', 'Dessert'],
            priceRange: '$$',
          }),
        }}
      />
      <div className="relative w-full bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <AboutUs />
          <Products />
          <MenuSection />
          <ContactUs />
        </main>
        <Footer />
      </div>
    </>
  );
}